import FieldName from './FieldName';

const formFields = [
    {
        name: FieldName.username,
        type: 'text',
        maxLength: 30,
        placeholder: 'Username',
    } as const,
    {
        name: FieldName.password,
        type: 'password',
        maxLength: 30,
        placeholder: 'Password',
    } as const,
];

export default formFields;
